import React from 'react';


function Footer() {
  return (
    <div>
        <footer>
          <p className="text copyright">SCARYPLACESNEARME © 2025</p>
          <nav>
            <a href="https://www.instagram.com/scaryplaces_/" target="_blank" rel="noreferrer">Instagram</a>
            <a href="mailto:scaryplac3s@gmail.com" target="_blank" rel="noreferrer">Email</a>
          </nav>
        </footer>
    </div>
  );
}

export default Footer;